import { GatewayRequestType, GatewayResponseType } from '../web-socket/types';

import { BaseMDSSubscriptionService } from './BaseMDSSubscription.service';

/**
 * FX Market Data Summary Subscription Service
 */
export class FxMDSSubscriptionService extends BaseMDSSubscriptionService {
  private static instance: FxMDSSubscriptionService;

  // Make the constructor private, to have a single instance
  // eslint-disable-next-line no-useless-constructor
  private constructor() {
    super();
  }

  static getInstance(): FxMDSSubscriptionService {
    if (!this.instance) {
      this.instance = new FxMDSSubscriptionService();
    }

    return this.instance;
  }

  protected getSubscriptionRequestType = (): GatewayRequestType => GatewayRequestType.FxQuoteDataSummary;

  protected getUnsubscriptionRequestType = (): GatewayRequestType => GatewayRequestType.None;

  protected getResponseType = (): GatewayResponseType => GatewayResponseType.DataSummaryResponse;
}
